<template>
  <span>
    <b-modal ref="composer" title="Schedule Meeting" size="xl" hide-footer>
      <b-alert show variant="warning">Use timezone {{member.timezone}}</b-alert>
      <div class="calendly" ref="calendly"></div>
    </b-modal>
    <b-dropdown right>
      <template v-slot:button-content>
        <img src="https://img.icons8.com/ios-glyphs/16/ffffff/calendar.png"/>
        Meeting
      </template>
      <b-dropdown-item target="_blank" @click="show(calendar)"  v-for="calendar in smartCalendars" :key="calendar.link">{{calendar.title}}</b-dropdown-item>
    </b-dropdown>
  </span>
</template>
<script>
export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      calendars: [
        {
          title: 'Tech Advisor',
          link: 'https://calendly.com/csuitecircle/tech-advisor-call'
        },
        {
          title: 'Marketing & Leadership Advisor',
          link: 'https://calendly.com/rajiv-csuite/30min'
        },
        {
          title: 'New Member Call',
          link: 'https://calendly.com/csuitecircle/ceo-network-new-member-call'
        }
      ]
    }
  },
  computed: {
    smartCalendars() {
      return this.calendars.map(c => {
        c.link = c.link += `?email=${encodeURIComponent(this.member.email)}&name=${encodeURIComponent(this.member.name)}&a1=${encodeURIComponent(this.member.phone)}&hide_event_type_details=1`;
        return c;
      })
    }
  },
  methods: {
    async show(calendar) {
      await this.$refs.composer.show();
      Calendly.initInlineWidget({
       url: calendar.link,
       parentElement: this.$refs.calendly,
       prefill: {
         name: this.member.name,
         email: this.member.email
       },
       utm: {}
      });
    },
    warn() {
      alert(`Select ${this.member.timezone} as the timezone`);
    },
  },
};
</script>
<style scoped>
  .calendly
  {
    height:700px;
  }
</style>
